import React from 'react';

export function AkamCheckIcon() {
  return (
    <svg width="19" height="15" viewBox="0 0 19 15" className='w-5 h-5' fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.678 2.17727C13.9139 2.42385 13.9139 2.82363 13.678 3.07021L4.89932 12.2448C4.66338 12.4913 4.28085 12.4913 4.04491 12.2448L0.31758 8.34935C0.0816404 8.10277 0.08164 7.70298 0.317579 7.4564L1.8128 5.89375C2.04874 5.64717 2.43127 5.64717 2.66721 5.89375L4.25851 7.5568C4.37648 7.68009 4.56774 7.68009 4.68571 7.5568L11.3283 0.614622C11.5643 0.368043 11.9468 0.368043 12.1827 0.614622L13.678 2.17727Z"
        fill="white"
      />
      <foreignObject x="2.19321" y="-0.377103" width="18.7503" height="17.0355">
        <div
          //   xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: 'blur(1.26px)',
            clipPath: 'url(#bgblur_0_9805_52745_clip_path)',
            height: '100%',
            width: '100%'
          }}
        />
      </foreignObject>
      <path
        data-figma-bg-blur-radius="2.51773"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.2483 3.88821C18.4842 4.13479 18.4842 4.53457 18.2483 4.78115L9.46963 13.9557C9.23369 14.2023 8.85116 14.2023 8.61522 13.9557L4.88789 10.0603C4.65195 9.8137 4.65195 9.41392 4.88789 9.16734L6.38311 7.60469C6.61905 7.35811 7.00158 7.35811 7.23752 7.60469L8.82882 9.26774C8.94679 9.39103 9.13806 9.39103 9.25603 9.26774L15.8986 2.32556C16.1346 2.07898 16.5171 2.07898 16.753 2.32556L18.2483 3.88821Z"
        fill="white"
        fillOpacity="0.75"
      />
      <defs>
        <clipPath id="bgblur_0_9805_52745_clip_path" transform="translate(-2.19321 0.377103)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.2483 3.88821C18.4842 4.13479 18.4842 4.53457 18.2483 4.78115L9.46963 13.9557C9.23369 14.2023 8.85116 14.2023 8.61522 13.9557L4.88789 10.0603C4.65195 9.8137 4.65195 9.41392 4.88789 9.16734L6.38311 7.60469C6.61905 7.35811 7.00158 7.35811 7.23752 7.60469L8.82882 9.26774C8.94679 9.39103 9.13806 9.39103 9.25603 9.26774L15.8986 2.32556C16.1346 2.07898 16.5171 2.07898 16.753 2.32556L18.2483 3.88821Z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
